import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Form, Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import AdminHeader from "./AdminHeader";

const Admin = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionStorage.getItem("authenticated")) {
      const enteredPassword = prompt("Enter Admin Password:");
      if (enteredPassword === "secureddata") {
        sessionStorage.setItem("authenticated", "true");
        setIsAuthenticated(true);
        fetchData();
      } else {
        alert("Incorrect password! Redirecting to Home...");
        navigate("/");
      }
    } else {
      setIsAuthenticated(true);
      fetchData();
    }
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Project_15_Myrtle_Rcm_ContactPageForm_SavedDetails"
      );
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value.toLowerCase());
  };

  const filteredData = data.filter((item) => {
    return Object.keys(item).some((key) => {
      if (item[key] !== null && item[key] !== undefined) {
        const value = item[key].toString().toLowerCase();
        return value.includes(filter);
      }
      return false;
    });
  });

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Filtered Data");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, "FilteredData.xlsx");
  };

  if (!isAuthenticated) {
    return null; // Prevent rendering if not authenticated
  }

  return (
    <>
      <AdminHeader />
      <Container className="mt-4">
        <h2 className="text-center">Admin Dashboard</h2>

        {/* Filter Input */}
        <Form.Group controlId="filter">
          <Form.Label>Filter Data</Form.Label>
          <Form.Control
            type="text"
            placeholder="Search by name,email, phone, message"
            value={filter}
            onChange={handleFilterChange}
          />
        </Form.Group>

        {/* Table */}
        <Table striped bordered hover responsive className="mt-3">
          <thead className="bg-primary text-white">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>providerType</th>
              <th>serviceType</th>

              <th>Message</th>
              <th>Date / Time</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.toReversed().map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.phone}</td>
                  <td>{item.providerType}</td>
                  <td>{item.serviceType}</td>

                  <td>{item.message}</td>
                  <td>{new Date(item.date).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-danger">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* Download Button */}
        <Button variant="success" onClick={downloadExcel} className="mt-3 mb-5">
          Download Excel
        </Button>
      </Container>
    </>
  );
};

export default Admin;
